import { AVATAR_PRESETS } from "@/lib/avatars";

interface AvatarPickerProps {
  name: string;
  value: string;
  onChange: (url: string) => void;
}

export default function AvatarPicker({ name, value, onChange }: AvatarPickerProps) {
  const initials = (name || "Gari user")
    .split(" ")
    .map((part) => part.charAt(0))
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div>
      <p className="mb-3 text-xs font-medium uppercase tracking-wider text-foreground-500">Profile photo</p>
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center">
        <span className="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary-500 font-heading text-2xl font-semibold text-background-50">
          {value ? (
            <img src={value} alt={`${name || "Your"} profile photo`} title="Your Gari profile photo" className="h-full w-full object-cover object-top" />
          ) : (
            initials
          )}
        </span>
        <div className="flex flex-wrap gap-3">
          {AVATAR_PRESETS.map((preset) => {
            const active = preset.url === value;
            return (
              <button
                key={preset.id}
                type="button"
                onClick={() => onChange(preset.url)}
                aria-label={`Use avatar ${preset.id}`}
                className={`h-14 w-14 overflow-hidden rounded-full border-2 transition-colors ${
                  active ? "border-primary-500" : "border-background-200 hover:border-primary-500/60"
                }`}
              >
                <img src={preset.url} alt={`Avatar option ${preset.id}`} className="h-full w-full object-cover object-top" />
              </button>
            );
          })}
          <button
            type="button"
            onClick={() => onChange("")}
            className={`inline-flex h-14 items-center gap-2 whitespace-nowrap rounded-full border px-4 text-xs font-medium transition-colors ${
              value === "" ? "border-primary-500 text-primary-400" : "border-background-200 text-foreground-600 hover:border-primary-500/60"
            }`}
          >
            <i className="ri-user-line"></i> Use initials
          </button>
        </div>
      </div>
    </div>
  );
}